<template>
  <dl class="information-wrapper" ...attributes>
    {{yield}}
  </dl>
</template>
